import { PackagePanelBaseDataProvider } from '../dataProvider/PackagePanelBaseDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class PackagePanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PackagePanelBaseDataProvider);
  }
}
